import { Divider, styled } from "@mui/material";

export const StyledDivider = styled(Divider)<{ colour?: string }>(
  ({ colour, theme }) => {
    let bg = theme.palette.divider;
    if (colour) {
      const parts = colour.split(".");
      if (parts.length > 1) {
        bg = theme.palette[parts[0]][parts[1]];
      } else {
        bg = theme.palette[parts[0]];
      }
    }

    return {
      background: `${bg}!important`,
    };
  }
);
